interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

function buildPages(current: number, total: number): (number | string)[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  const pages: (number | string)[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("...");
  pages.push(total);
  return pages;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = buildPages(current, total);

  const go = (p: number) => {
    if (p < 1 || p > total || p === current) return;
    onChange(p);
  };

  return (
    <nav className="flex items-center justify-center gap-1.5 md:gap-2 mt-8 flex-wrap" aria-label="分页导航">
      <button
        type="button"
        onClick={() => go(current - 1)}
        disabled={current === 1}
        className="h-9 px-3 rounded-md border border-background-200 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer flex items-center gap-1"
      >
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-left-s-line text-lg" />
        </span>
        上一页
      </button>

      {pages.map((p, idx) =>
        typeof p === "number" ? (
          <button
            key={p}
            type="button"
            onClick={() => go(p)}
            className={`w-9 h-9 rounded-md text-sm font-medium transition-colors cursor-pointer ${
              p === current
                ? "bg-primary-500 text-background-50"
                : "border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={`dot-${idx}`} className="w-6 text-center text-foreground-400">
            …
          </span>
        ),
      )}

      <button
        type="button"
        onClick={() => go(current + 1)}
        disabled={current === total}
        className="h-9 px-3 rounded-md border border-background-200 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer flex items-center gap-1"
      >
        下一页
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-right-s-line text-lg" />
        </span>
      </button>
    </nav>
  );
}